import RestApi from '@utilities/RestApi'
import Axios from 'axios'

import AdminActionsApi from '@modules/admin/rooms/adminActions.Api'

class CustomerSingleton {
  constructor() {
    const httpConfig = {
      baseURL: import.meta.env.VITE_REACT_APP_URL_CUSTOMER,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    this.client = Axios.create(httpConfig)
    console.info(`Axios instance base URL is ${this.client.defaults.baseURL}`)

    // this.client.interceptors.request.use(refreshTokenInterceptor);

    // IMPLEMENTATIONS
    this.customers = new RestApi(this.client, 'api/v3/pendingCompanyUsers')
    this.migrateConsultations = new RestApi(this.client, 'migrate-rooms-to-consultations')
    this.company = new RestApi(this.client, 'api/companies')
    this.companyConfigurations = new RestApi(this.client, '/admin/v1/company-configurations')
    this.adminRooms = new AdminActionsApi(this.client)
  }

  static get instance() {
    return this._instance || (this._instance = new this())
  }

  updateHeaders(headerLines) {
    this.client.defaults.headers.common = {
      ...this.client.defaults.headers.common,
      ...headerLines,
    }
  }

  // sets the default headers
  removeHeaders() {
    this.client.defaults.headers.common = {
      Accept: 'application/json',
    }
  }
}

export default CustomerSingleton.instance
